const SPACE = 20;
export const PADDING = SPACE;
export const MARGIN = SPACE;
export const layout = {
    labelCol: { span: 16 },
    wrapperCol: { span: 8 },
};
